import { FunctionComponent } from "react";
import { Navigate, RouteObject, useRoutes } from "react-router";
import DeleteAccountParent from "../pages/delete-account-parent";
import DeleteAccountChildren from "../pages/delete-account-children";
import PrivacyPolicy from "../pages/privacy-policy";
import ChildPage from "src/pages/child-page";
import ParentPage from "src/pages/parent-page";

interface MainRouterProps {}
export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate replace to="/child-page" />,
  },
  { path: "privacy-policy", element: <PrivacyPolicy /> },
  { path: "delete-account-parent", element: <DeleteAccountParent /> },
  { path: "delete-account-children", element: <DeleteAccountChildren /> },
  { path: "parent-page", element: <ParentPage /> },
  { path: "child-page", element: <ChildPage /> },
];
const MainRouter: FunctionComponent<MainRouterProps> = () => {
  let element = useRoutes(routes);
  return element;
};

export default MainRouter;
